module.exports = __webpack_public_path__ + "img/file2.fd19d96b.svg";